import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
var PLabelComponent = /** @class */ (function () {
    function PLabelComponent() {
    }
    PLabelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'item-plabel',
                    template: '<p class="{{ cls }}">{{ txt }}</p>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    PLabelComponent.propDecorators = {
        cls: [{ type: Input }],
        txt: [{ type: Input }]
    };
    return PLabelComponent;
}());
export { PLabelComponent };
//# sourceMappingURL=plabel.component.js.map